var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 48,
    viewBox: "0 0 153 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3599 47.4241L33.339 0L26.7833 14.6885L22.8833 1.34427L15.882 25.9679L0 28.1761L0.682088 35.9523L2.90115 35.8627L3.42712 40.3029L4.99137 35.7792L5.75531 35.7493L6.61171 41.5039L8.46699 35.6404L13.1855 35.4524L9.61896 48L40.3599 47.4241Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2515 21.8083C54.3443 21.8083 52.5208 23.3226 51.9221 24.1089V17.5173H45.709V37.1533H51.9221V28.934C51.9221 27.251 52.7194 25.9888 54.8293 25.9888C56.9392 25.9888 57.6501 27.2794 57.6501 28.934V37.1533H63.8632V27.5315C63.8632 23.7165 61.441 21.8098 57.2515 21.8098V21.8083Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2085 21.8083C89.5067 21.8083 84.2622 23.912 84.2622 29.6904C84.2622 35.4689 89.5052 37.5725 94.2085 37.5725C98.9119 37.5725 104.126 35.4689 104.126 29.6904C104.126 23.912 98.8831 21.8083 94.2085 21.8083ZM94.2085 33.589C91.3013 33.589 90.2191 31.7091 90.2191 29.6904C90.2191 27.6718 91.3013 25.7919 94.2085 25.7919C97.1157 25.7919 98.1692 27.6718 98.1692 29.6904C98.1692 31.7091 97.0869 33.589 94.2085 33.589Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.093 21.8083C69.3911 21.8083 64.1466 23.912 64.1466 29.6904C64.1466 35.4689 69.3896 37.5725 74.093 37.5725C78.7964 37.5725 84.0105 35.4689 84.0105 29.6904C84.0105 23.912 78.7676 21.8083 74.093 21.8083ZM74.093 33.589C71.1858 33.589 70.1035 31.7091 70.1035 29.6904C70.1035 27.6718 71.1858 25.7919 74.093 25.7919C77.0002 25.7919 78.0536 27.6718 78.0536 29.6904C78.0536 31.7091 76.9714 33.589 74.093 33.589Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.708 30.4468L119.716 22.2007H114.386L111.394 30.4468L108.545 22.2007H102.131L108.402 37.1518H113.988L117.065 28.7639L120.114 37.1518H125.7L131.969 22.2007H125.557L122.708 30.4468Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.182 16.4506H131.969V37.1518H138.182V16.4506Z",
    fill: "#1F6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.807 21.8083C147.501 21.8083 145.82 23.5196 145.25 24.5013V22.2007H139.037V37.1518H145.25V30.784C145.25 28.4565 146.134 26.5483 149.326 26.5483C150.693 26.5483 151.719 26.9123 152.489 27.2212H153.002V22.0604C152.489 21.8918 151.777 21.8083 150.807 21.8083Z",
    fill: "#1F6BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_1707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8a1038c5a7199bffd6a641bb27f710e.svg";
export { ForwardRef as ReactComponent };